module.exports = __webpack_public_path__ + "static/2-48e258270e5d3781e7192abac1cd0407.jpg";